import x from './HuntHorses';

export default x;
